import { AchievementManager } from './AchievementManager'
import { AvatarManager } from './avatar/AvatarManager'
import { CommunicationManager } from './communication/CommunicationManager'
import { Connector } from './communication/firebase-connector'
import { JSNGPrizeHistoryApi } from './communication/jackpot-sit-and-go/JsngPrizeHistoryApi'
import { PingManager } from './communication/PingManager'
import { SoundManager } from './sound/SoundManager'
import { TableManager } from './TableManager'
import { TournamentManager } from './tournaments/TournamentManager'
import { NotificationsManager } from './ui/NotificationsManager'
import { ToolbarManager } from './ui/views/toolbar/ToolbarManager'
import { ViewManager } from './ui/views/ViewManager'

class AppCtx {
	// Accessed directly
	lobbySoundManager: SoundManager
	tableManager: TableManager
	viewManager: ViewManager
	jsngPrizeHistoryApi: JSNGPrizeHistoryApi

	// Accessed through getters/setters
	achievementManager: AchievementManager
	avatarManager: AvatarManager
	communicationManager: CommunicationManager
	connector: Connector
	notificationsManager: NotificationsManager
	pingManager: PingManager
	toolbarManager: ToolbarManager
	tournamentManager: TournamentManager

	getAchievementManager() { return this.achievementManager }
	getAvatarManager() { return this.avatarManager }
	getCommunicationManager() { return this.communicationManager }
	getConnector() { return this.connector }
	getNotificationsManager() { return this.notificationsManager }
	getPingManager() { return this.pingManager }
	getToolbarManager() { return this.toolbarManager }
	getTournamentManager() { return this.tournamentManager }

	setAchievementManager(achievementManager: AchievementManager) { this.achievementManager = achievementManager }
	setAvatarManager(avatarManager: AvatarManager) { this.avatarManager = avatarManager }
	setCommunicationManager(communicationManager: CommunicationManager) {
		this.communicationManager = communicationManager
	}
	setConnector(connector: Connector) { this.connector = connector }
	setNotificationsManager(notificationsManager: NotificationsManager) {
		this.notificationsManager = notificationsManager
	}
	setPingManager(pingManager: PingManager) { this.pingManager = pingManager }
	setToolbarManager(toolbarManager: ToolbarManager) { this.toolbarManager = toolbarManager }
	setTournamentManager(tournamentManager: TournamentManager) { this.tournamentManager = tournamentManager }
}

export let appCtx = new AppCtx()

export function resetAppCtx() {
	appCtx = new AppCtx()
}
